export const UNICODE_WHITESPACE_RE = /\p{White_Space}/u;
export const UNICODE_INVISIBLE_RE = /[\p{M}\p{Cf}\p{Default_Ignorable_Code_Point}]/u;
export const REPLACEMENT_CHARACTER = '\uFFFD'; // �
export const LATIN1_MAX_CODEPOINT = 0xff;
